import React, { createContext, useContext } from 'react';
import { useOperatorProficiencyData } from '@/hooks/AssetsPreviewPage/OperatorProficiency/useOperatorProficiencyData';
import type { OperatorData, FleetAbuse, FleetInsight } from '@/types/features/operator-proficiency/operator-proficiency.types';
import type { DataLayer } from '@/types/shared/data-layers.types';
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import type { SerializedError } from '@reduxjs/toolkit';
import type { OperatorProficiencyMetadata } from '@/modules/AssetsPreviewPage/OperatorProficiency/utils/transformMetadata';

interface OperatorProficiencyContextType {
  data: OperatorData[];
  chartData: FleetAbuse[];
  listData: OperatorData[];
  dataLayers: DataLayer[];
  loading: boolean;
  error: string | FetchBaseQueryError | SerializedError | null | undefined;
  metadata: OperatorProficiencyMetadata | null;
  filters: {
    months_range?: number;
    asset_type: string[];
  };
  updateFilter: (filterId: string, value: string | number | string[]) => void;
}

const OperatorProficiencyContext = createContext<OperatorProficiencyContextType | undefined>(undefined);

export const OperatorProficiencyProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const operatorProficiencyData = useOperatorProficiencyData();
  
  return (
    <OperatorProficiencyContext.Provider value={operatorProficiencyData}>
      {children}
    </OperatorProficiencyContext.Provider>
  );
};

export const useOperatorProficiency = () => {
  const context = useContext(OperatorProficiencyContext);
  if (context === undefined) {
    throw new Error('useOperatorProficiency must be used within an OperatorProficiencyProvider');
  }
  return context;
};